import React from 'react';

import PropTypes from 'prop-types';

import Country from './Country/Country';
import {
    ColumnMenu,
    ColumnMenuItem,
} from '../../MenuTypes/ColumnMenu/ColumnMenu';

function MultiColumnMenu(props) {
    const {
        columns,
        countryLocaleConfigs,
        onComplete = () => undefined,
        onItemClick = () => undefined,
        path,
    } = props;

    const onClick = (locale) => {
        onItemClick(locale);
        onComplete();
    };

    return (
        <ColumnMenu
            columns={columns}
        >
            {countryLocaleConfigs.map((countryLocaleConfig) => (
                <ColumnMenuItem
                    key={countryLocaleConfig.countryCode}
                >
                    <Country
                        localeConfig={countryLocaleConfig}
                        onClick={onClick}
                        path={path}
                    />
                </ColumnMenuItem>
            ))}
        </ColumnMenu>
    );
}

MultiColumnMenu.propTypes = {
    columns: PropTypes.number.isRequired,
    countryLocaleConfigs: PropTypes.arrayOf(PropTypes.object).isRequired,
    onComplete: PropTypes.func,
    onItemClick: PropTypes.func,
    path: PropTypes.string.isRequired,
};

export { MultiColumnMenu };
export default MultiColumnMenu;
